const Communicator = {
  AGENT: 'AGENT',
  API: 'API',
  AUTOMATED: 'AUTOMATION',
  CUSTOMER: 'CUSTOMER',
  EXTERNAL: 'EXTERNAL',
  INTERNAL: 'INTERNAL',
  SYSTEM: 'SYSTEM',
  DEFAULT: '',
};

export default Communicator;

export const inboundCommunicators = [Communicator.CUSTOMER, Communicator.EXTERNAL, Communicator.INTERNAL];

const SIDEKICK_SYSTEM_IDS = new Set(['SIDEKICK', 'SIDEKICK_V2']);

export function isApiInitiator(initiator) {
  if (!initiator) return false;
  return initiator.type === Communicator.API;
}

export function isGladlyAiInitiator(initiator) {
  if (!initiator) return false;
  return initiator.type === Communicator.SYSTEM && SIDEKICK_SYSTEM_IDS.has(initiator.id);
}

export function isRuleInitiator(initiator) {
  if (!initiator) return false;
  return initiator.type === Communicator.AUTOMATED;
}
